<template>
  <app-slide>
    <article class="layout" id="start">
        <div class="container">
          <div class="row">
              <div class="col-xs-12 text-content">
                  <h2 class="margin-bottom-2">{{getTranslation('saved')}}</h2>
                  <p v-if="noFavs">{{getTranslation('your-saved-items-will-appear-here')}}</p>
              </div>
              <div class="col-xs-12 text-content">
                  <h3  v-if="favArtists.length" class="margin-bottom-2">{{getTranslation('artists')}}</h3>
                   <table class="table-styles" cellPadding="0" cellSpacing="0">
                        <tr v-for="item in orderBy(favArtists, 'code')" :key="item.id">
                          <td class="border-bottom">
                            <router-link tag="p" class="no-margin" :to="getUrl(item.code)" >{{item.title}}</router-link>
                          </td>
                          <td class="border-bottom">
                            <p class="text-right no-margin" @click="removeArtist(item)">{{getTranslation('remove')}}</p>
                          </td>
                        </tr>
                  </table>
              </div>
              <div class="col-xs-12 text-content margin-top-4">
                  <h3 v-if="favVenues.length" class="margin-bottom-2">{{getTranslation('venues')}}</h3>
                   <table class="table-styles" cellPadding="0" cellSpacing="0">
                        <tr v-for="item in favVenues" :key="item.code">
                          <td class="border-bottom">
                            <router-link tag="p" class="no-margin" :to="getVenueUrl(item.code)" >{{item.title}}</router-link>
                          </td>
                          <td class="border-bottom">
                            <p class="text-right no-margin" @click="removeVenue(item)">{{getTranslation('remove')}}</p>
                          </td>
                        </tr>
                  </table>
              </div>
          </div>
          </div>
    </article>
  </app-slide>
</template>


<script>
  import {store} from '../store/store'
  import appSlide from '../transitions/AppSlide'
  import mixinLanguages from '../mixins/Language'
  // import HomeRiboca from '../components/HomeRiboca'
  // import slide from '../mixins/PageSlide'
  export default {
    name: 'savedIndex',
    mixins: [mixinLanguages],
    components: {
      appSlide
    },
    data() {
      return {
        
      }
    },
    mounted () {
      store.dispatch('setDestUrl', '__/__');
      store.dispatch('setDestChange', false);
    },
    computed:{
      lang() { 
        return this.$store.state.langUrl;
      },
      favArtists() { 
        return this.$store.state.favArtists;
      },
      favEvents() { 
        return this.$store.state.favEvents;
      },
      favVenues() { 
        return this.$store.state.favVenues;
      },
      noFavs() {
        if( this.favVenues.length == 0 && this.favArtists.length == 0 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    watch: {
      lang(newValue) {
       
      },
      favArtists(newValue) { 
        
      },
      favEvents(newValue) { 
        
      },
      favVenues(newValue) { 
        
      }
    },
    methods: {
      removeArtist(obj) {
        let index = this.$store.getters.getFavArtists.findIndex(p => p.code == obj.code);
        store.commit('removeFavArtists', index);
      },
      removeVenue(obj) {
        let index = this.$store.getters.getFavVenues.findIndex(p => p.code == obj.code);
        store.commit('removeFavVenues', index);
      },
      removeEvent(obj) {
        let index = this.$store.getters.getFavEvents.findIndex(p => p.slug == obj.slug);
        store.commit('removeFavEvents', index);
      },
      getUrl(code) {
        return String('/' + code + '/00');
      },
      getVenueUrl(code) {
        return String('/99/' + code );
      },
    }
  }
</script>

<style lang="scss">
  .fav-style {
    margin: 0;
    padding: 0;
    li {
      list-style: none;
      margin: 0;
      padding: 6px 0;
      border-top:1px solid black;
      p {
        margin: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/SavedIndex.vue